module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-bb5f1ce6c88872b762c05f2de7a9c81f.png";